export const mm = {
  slides: {
    cultOfTheLamb: {
      name: 'Cult of the Lamb',
      background: '/image/cult-of-the-lamb/CultOfTheLamb-NoLogo.png',
      logo: '/image/cult-of-the-lamb/Logo.png',
      video: '/video/cotl_short.mp4',
      to: '/games/cult-of-the-lamb',
      content: 'Cult of the Lamb casts players in the role of a possessed lamb saved from annihilation by an ominous stranger, and must repay their debt by building a loyal following in his name.',
    },
    adventurePals: {
      name: 'The Adventure Pals',
      background: '/image/adventure-pals/adventure-pals-faded.jpg',
      leftImage: '/image/adventure-pals/adventure-pals-human.png',
      rightImage: '/image/adventure-pals/adventure-pals-giraffe.png',
      logo: '/image/adventure-pals/adventure-pals-logo.png',
      video: '/video/pals_small.mp4',
      to: '/games/the-adventure-pals',
      content: 'The Adventure Pals is an epic adventure platformer fueled by imagination, friendship, and the dark side of hot dogs. Your dad has been dadnapped and you, your pet rock, and giraffe must fight your way to save the world!',
    },
    neverGiveUp: {
      name: 'Never Give Up',
      background: '/image/never-give-up/ngu_screenshot_compressed.jpg',
      leftImage: '/image/never-give-up/bats.png',
      rightImage: '/image/never-give-up/Flare-NGU-1.png',
      logo: '/image/never-give-up/LOGO_BIG.png',
      video: '/video/ngu_short.mp4',
      to: '/games/never-give-up',
      content: 'Never give up is a hardcore platformer determined to turn you into bloody chunks. Run, jump, and slide your way through ever-changing levels that get harder each time you succeed.',
    },
  },
  games: {
    cultOfTheLamb: {
      name: 'Cult of the Lamb',
      to: '/games/cult-of-the-lamb',
      logo: '/image/cult-of-the-lamb/Logo.png',
      banner: { src: '/image/cult-of-the-lamb/CultOfTheLamb-NoLogo.png', video: 'https://www.cultofthelamb.com/video/keyart.mp4' },
      platforms: {
        playstation: 'https://store.playstation.com/product/EP3643-PPSA06465_00-3571249245584917/',
        steam: 'https://store.steampowered.com/app/1313140',
        gog: 'https://www.gog.com/en/game/cult_of_the_lamb',
        switch: 'https://www.nintendo.com/store/products/cult-of-the-lamb-switch/',
        xbox: 'https://www.xbox.com/games/store/cult-of-the-lamb/9PNLPMP1GGH5',
      },
    },
    adventurePals: {
      name: 'The Adventure Pals',
      to: '/games/the-adventure-pals',
      logo: '/image/adventure-pals/adventure-pals-logo.png',
      banner: { src: '/image/adventure-pals/adventure-pals-banner.png' },
      platforms: {
        playstation: 'https://store.playstation.com/product/EP2638-CUSA09661_00-0000000000000001',
        steam: 'https://store.steampowered.com/app/396710/The_Adventure_Pals/',
        gog: 'https://www.gog.com/en/game/adventure_pals',
        switch: 'https://www.nintendo.com/store/products/the-adventure-pals-switch/',
        xbox: 'https://www.xbox.com/games/store/the-adventure-pals/bzgt1plmrbkx',
      },
    },
    neverGiveUp: {
      name: 'Never Give Up',
      to: '/games/never-give-up',
      logo: '/image/never-give-up/never-give-up-logo.png',
      banner: { src: '/image/never-give-up/NGU_Promo_Website.png' },
      platforms: {
        steam: 'https://store.steampowered.com/app/609420/Never_Give_Up/',
        gog: 'https://www.gog.com/en/game/never_give_up',
        switch: 'https://www.nintendo.com/store/products/never-give-up-switch/',
      },
    },
    unicycleGiraffe: {
      name: 'Unicycle Giraffe',
      to: '/games/unicycle-giraffe',
      logo: '/image/unicycle-giraffe/unicyclegiraffe-logo.png',
      banner: { src: '/image/unicycle-giraffe/background.png' },
      // App Store / Google Play listings have been delisted.
      platforms: {},
    },
  },
} as const

export default defineNuxtPlugin(() => {
  if (typeof window !== 'undefined')
    (window as unknown as { $mm: typeof mm }).$mm = mm

  return {
    provide: {
      mm,
    },
  }
})
